import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary';
  href?: string;
  children: React.ReactNode;
  className?: string;
}
export function Button({
  variant = 'primary',
  href,
  children,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center whitespace-nowrap px-8 py-3.5 rounded-full font-sans text-[15px] font-semibold tracking-[0.01em] leading-none transition-all duration-300 ease-out focus:outline-none focus:ring-2 focus:ring-brand-sage focus:ring-offset-2 focus:ring-offset-brand-cream';
  const variants = {
    primary: 'bg-brand-eucalyptus text-brand-warmwhite hover:bg-[#4A5A4E] hover:shadow-md',
    secondary: 'bg-transparent border border-brand-eucalyptus text-brand-eucalyptus hover:bg-brand-eucalyptus/5'
  };
  const combinedClassName = `${baseStyles} ${variants[variant]} ${className}`;
  if (href) {
    const isExternal = /^https?:\/\//.test(href);
    return <a href={href} className={combinedClassName} {...isExternal ? {
      target: '_blank',
      rel: 'noopener noreferrer'
    } : {}} data-id="element-149">
        {children}
      </a>;
  }
  return <button className={combinedClassName} {...props} data-id="element-150">
      {children}
    </button>;
}